import React, { useState } from "react";
import GrayCard from "components/gray-card";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import styled from "styled-components";
import Radio from "components/radio";

import Modal from "components/modal";
import EditCountries from "./components/editCountries";
import { ICountry } from "../..";
import { Countries } from "constants/countries";

interface IProps {
  countries?: ICountry[];
  setCountries: (value: ICountry[]) => void;
}
const Country = ({ countries, setCountries }: IProps) => {
  const [limit, setLimit] = useState(countries && countries.length > 0);
  const [modalOpen, setModalOpen] = useState(false);

  const CountryDifference =
    Countries.length - ((countries && countries.length) || 0);
  return (
    <GrayCard title="Country">
      <Typography color={Colors.grey500}>
        Would you like to add country restrictions and limit availability of
        your release
      </Typography>
      <RadioItems>
        <RadioItem>
          <Radio value={limit} onClick={() => setLimit(true)} />
          <Typography ml="0.4" color={Colors.white200}>
            Yes
          </Typography>
        </RadioItem>
        <RadioItem>
          <Radio value={!limit} onClick={() => setLimit(false)} />
          <Typography ml="0.4" color={Colors.white200}>
            No
          </Typography>
        </RadioItem>
      </RadioItems>
      {limit && (
        <>
          <Typography mt="2.4" mb="0.4" weight="medium" color={Colors.grey400}>
            Countries
          </Typography>
          <CountriesButton onClick={() => setModalOpen(true)}>
            <Typography size="s" color={Colors.grey400}>
              {CountryDifference
                ? `${CountryDifference} Countries Excluded`
                : "     All Countries"}
            </Typography>
          </CountriesButton>
          {modalOpen && (
            <Modal isActive={modalOpen} closeModal={() => setModalOpen(false)}>
              <EditCountries
                close={() => setModalOpen(false)}
                confirm={(countries) => {
                  setCountries(countries);
                }}
                countries={countries || []}
              />
            </Modal>
          )}
        </>
      )}
    </GrayCard>
  );
};

export default Country;

const RadioItems = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1.6rem;
`;

const RadioItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 2.4rem;
`;

const CountriesButton = styled.div`
  width: 100%;
  padding: 1.4rem 1rem;
  cursor: pointer;
  border-radius: 0.8rem;
  border: 1px solid ${Colors.grey500};
`;
